import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'components/snackbar';
import API from '../API';
// autht
import { useAuthContext } from '../../auth/useAuthContext';

export const useUploadFiles = () => { 
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { user, logout } = useAuthContext(); 
  const { mutate, isLoading } = useMutation(
    (payload) => API.post(`/third-party/file-upload/upload-files-admin/${user?.websiteProjectId}`, payload),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(['_uploadFiles']);
        enqueueSnackbar(data?.data?.message || 'success');
      },
      onError: (error) => {
        const errorMessage = error?.response?.data?.message;
        enqueueSnackbar(errorMessage, { variant: 'error' });
        console.error(error);
      },
    }
  );
  return {
    mutate,
    isLoading,
  };
};
